import { render, staticRenderFns } from "./NavigationDashboard.vue?vue&type=template&id=38a18059&scoped=true"
import script from "./NavigationDashboard.vue?vue&type=script&lang=js"
export * from "./NavigationDashboard.vue?vue&type=script&lang=js"
import style0 from "./NavigationDashboard.vue?vue&type=style&index=0&id=38a18059&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a18059",
  null
  
)

export default component.exports